import React from 'react';
import classnames from 'classnames';

const Popover = ({ children, grow, menuOpen }) => {
  const popoverClass = classnames(
    'dropdown-nav h-0 lg:group-hover:h-auto lg:h-auto lg:absolute lg:flex lg:flex-col lg:items-center lg:py-3 invisible lg:group-hover:visible',
    {
      open: menuOpen,
      'lg:w-64': !grow,
    }
  );

  return (
    <div className={popoverClass}>
      <svg className="absolute top-0 hidden w-6 h-3 fill-current text-whisper lg:block">
        <path d="M24 10H0L9.879.817c1.171-1.09 3.07-1.09 4.242 0L24 10z"></path>
      </svg>

      <div className="relative w-full -mt-1 overflow-hidden lg:shadow-xl lg:rounded lg:p-2 lg:bg-white lg:px-0 lg:border lg:border-b-0 lg:border-whisper">
        {children}
      </div>
    </div>
  );
};

export default Popover;
